module.exports = __webpack_public_path__ + "static/img/fail-qrcode.a9399f7e.jpg";